module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('el-form', {
    attrs: {
      "label-position": "top"
    }
  }, [(_vm.tenancy && _vm.tenancy.length > 1) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tenancy,
      "border": "",
      "max-height": "250"
    },
    on: {
      "current-change": _vm.checked
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "40"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.renewal.tenancy_id === _vm.tenancy[scope.$index].id) ? _c('i', {
          staticClass: "fa fa-check"
        }) : _c('i', {
          staticClass: "fa fa-nothing"
        })]
      }
    }], null, false, 554601083)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "landStatus",
      "label": "Land Status"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "landType",
      "label": "Land Type"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "owner.name",
      "label": "Landowner"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    attrs: {
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24,
      "align": "center"
    }
  }, [(_vm.renewal.expiry) ? _c('h4', [_vm._v("Tenancy expires on: "), _c('b', [_vm._v(_vm._s(_vm.formatDate(_vm.renewal.expiry)))])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', [(_vm.owner) ? _c('span', {
    staticClass: "text-black"
  }, [_vm._v(_vm._s(_vm.owner.name))]) : _vm._e(), _c('span', {
    staticClass: "text-primary"
  }, [_vm._v(": " + _vm._s(_vm.site.siteName))])]), _vm._v(" "), (_vm.site.handover) ? _c('p', [_c('center', [_vm._v("Handover: " + _vm._s(_vm.formatDate(_vm.site.handover))), (_vm.tenancy.deposit) ? _c('span', [_vm._v(" | Deposit: " + _vm._s(_vm.formatMoney(_vm.tenancy.deposit)))]) : _vm._e(), (_vm.tenancy.depositMonths) ? _c('span', [_vm._v(" for " + _vm._s(_vm.plural('month', _vm.tenancy.depositMonths, true)))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('hr')])], 1), _vm._v(" "), (_vm.prevStarted && _vm.prevExpiry) ? _c('small', [_c('center', [_vm._v("Previous Renewal from "), _c('b', [_vm._v(_vm._s(_vm.formatDate(_vm.prevStarted)))]), _vm._v(" to "), _c('b', [_vm._v(_vm._s(_vm.formatDate(_vm.prevExpiry)))]), _vm._v(".")])], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('date-input', {
    attrs: {
      "label": "Started"
    },
    on: {
      "change": _vm.onChange
    },
    model: {
      value: (_vm.renewal.started),
      callback: function($$v) {
        _vm.$set(_vm.renewal, "started", $$v)
      },
      expression: "renewal.started"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tenor (months)"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-slider', {
    attrs: {
      "min": 6,
      "max": 1188,
      "step": 6,
      "show-input": ""
    },
    on: {
      "change": _vm.onChange
    },
    model: {
      value: (_vm.renewal.months),
      callback: function($$v) {
        _vm.$set(_vm.renewal, "months", $$v)
      },
      expression: "renewal.months"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('b', [_vm._v(_vm._s(Number(_vm.renewal.months / 12)))]), _vm._v(" " + _vm._s(_vm.plural('year', _vm.renewal.months / 12)) + "\n            ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6,
      "align": "center"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Expiry"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.formatDate(_vm.renewal.expiry)))])])], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('el-col', {
    attrs: {
      "md": 24,
      "lg": 14
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('currency-input', {
    on: {
      "change": _vm.onChange
    },
    model: {
      value: (_vm.renewal.amount),
      callback: function($$v) {
        _vm.$set(_vm.renewal, "amount", $$v)
      },
      expression: "renewal.amount"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('check-box', {
    attrs: {
      "label": "Taxable"
    },
    on: {
      "change": _vm.onChange
    },
    model: {
      value: (_vm.renewal.taxable),
      callback: function($$v) {
        _vm.$set(_vm.renewal, "taxable", $$v)
      },
      expression: "renewal.taxable"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Increment %"
    }
  }, [_c('el-slider', {
    attrs: {
      "min": 0,
      "max": 1000,
      "show-input": ""
    },
    on: {
      "change": _vm.onChange
    },
    model: {
      value: (_vm.renewal.increment),
      callback: function($$v) {
        _vm.$set(_vm.renewal, "increment", $$v)
      },
      expression: "renewal.increment"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 8,
      "sm": 8,
      "md": 8,
      "lg": 4,
      "align": "center"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Amount"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.formatMoney(_vm.renewal.amount)))])])], 1), _vm._v(" "), (_vm.renewal.taxable) ? _c('el-col', {
    attrs: {
      "xs": 8,
      "sm": 8,
      "md": 8,
      "lg": 2,
      "align": "center"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tax"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.formatMoney(_vm.renewal.tax)))])])], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 8,
      "sm": 8,
      "md": 8,
      "lg": 4,
      "align": "center"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Total"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.formatMoney(_vm.renewal.total)))])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24d866c7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/property/Renewal.vue
// module id = 1459
// module chunks = 0